export default __webpack_public_path__ + "static/media/nadia.d24b9948.png";